<template>
<div id="enterprise-list-wrapper">
  <mainHeader class="mainHeader"></mainHeader>
  <div class="wrapper">
    <van-search v-model="seacherValue" placeholder="请输入供应商关键字"   @search="onSearch"/>
    <!--金牌供应商-->
    <div class="section section3">
      <div class="content">
        <div class="item" v-for="(value,index) in vipSupplierData" :key="index" @click="businessInfoClick(value.id)">
          <!-- <img class="vip" v-show="index < 3" :src="vipImages[index]" /> -->
          <!-- <div class="number" v-show="index >= 3">{{index+1}}</div> -->
          <div class="image dimage" v-show="value.logo == null"></div>
              <div class="image" :style="{backgroundImage:'url('+imageUrl+value.logo+')'}" ></div>
              <div class="title">{{value.company_name}}</div>
              <!--<div class="code"></div>-->
        </div>
          </div>
    </div>
    <!-- <mainFooter class="mainFooter"></mainFooter> -->

  </div>
</div>

</template>

<script>
import mainHeader from '../view/header'
import mainFooter from '../view/footer'

export default{
  data () {
    return {
      imageUrl: this.utils.ResourceUrl,
      seacherValue : "",
      
      vipSupplierData: [], // 金牌供应商
      recSupplierData: [], // 推荐供应商
      buyData: [],
      newsData: [],
     postQuery : {
       page :1,
       province : "",
       sign : "",
       type : "",
       order : "desc",
       words : ""
     }
     
      
    }
  },
  watch: {
    $router () {
    }
  },
  methods: {
    onSearch(val){
      console.log(val);
    },
    
    loadData: function () {
      var _this = this
      // 金牌供应商 http://www.zxzx119.com/account/supplier/list?gold=1
      this.utils.GET(this.accountUrl + '/supplier/list?gold=1',
        function (data) {
          _this.vipSupplierData = data.data.rows
        })
      
    }
  },
  components: { // 注册组件
    mainHeader,
    mainFooter
  },
  mounted () {
    this.loadData()
  }
}
</script>

<style scoped>

.mainHeader{
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
  z-index: 500;
}
.wrapper{
  background-color: #F6F6F6;
  width: 100%;
  /*margin-bottom: 70px;*/
  margin-top: 55px;
}

.section{
  position: relative;
  /*border-bottom: yellow solid 1px;
  box-sizing: border-box;*/
}
.section3{
  margin-bottom: 10px;
}
.section2{
  height: 200px;
}
.section2 .items{
  position: absolute;
  margin-top: 10px;
}
.section2 .items .item{
  float: left;
  width: calc((100% - 45px)/4);
  height: 83px;
  text-align: center;
  margin-left: 5px;
  margin-top: 5px;
  background-color: #FFFFFF;
  border-radius: 5px;
  box-shadow: 0px 4px 4px rgba(0,0,0,0.1);
}
.section2 .items .item:nth-child(1){
  margin-left: 15px;
}
.section2 .items .item:nth-child(5){
  margin-left: 15px;
}

.section2 .items .item img{
  margin-top: 15px;
  width: 30px;
  height: 30px;
}
.section2 .items .item span{
  color: #000000;
  font-size: 13px;
}
.section3{
  height: 370px;
  background-color: #FFFFFF;
}
.section3 .title{
  position: absolute;
  top: 0px;
  left: 15px;
  height: 45px;
  line-height: 45px;
  font-size: 17px;
  color: #000000;
  font-weight: bold;
}
.section3 .content{
  position: absolute;
  top: 45px;
  /*left: 15px;*/
  width: 100%;
  height: 325px;
  overflow: hidden;
}
.section3 .content .item{
  position: relative;
  width: 100%;
  height: 65px;
  border-bottom: solid #EEEEEE 1px;
  box-sizing: border-box;
}
.section3 .content .item .vip{
  position: absolute;
  left: 18px;
  top: 18px;
  width: 24px;
  height: 29px;
}
.section3 .content .item .number{
  position: absolute;
  left: 20px;
  top: 22px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  background-color: #EEEEEE;
  border: solid #999999 1px;
  box-sizing: border-box;
  border-radius: 10px;
  color: #999999;
  font-size: 13px;
  text-align: center;
}
.section3 .content .item .image{
  position: absolute;
  left: 15px;
  top: 15px;
  width: 35px;
  height: 35px;
  background-image: url(../assets/icon_new_default.png);
  background-size: cover;
  background-position: center center;
  border: #EEEEEE solid 1px;
  box-sizing: border-box;
}
.section3 .content .item .title{
  position: absolute;
  left: 65px;
  right: 50px;
  top: 15px;
  bottom: 15px;
  height: 35px;
  line-height: 18px;
  font-size: 13px;
  color: #000000;
  /*vertical-align: middle;*/
}
.section3 .content .item .code{
  position: absolute;
  right: 15px;
  top: 22px;
  width: 20px;
  height: 20px;
  background-image: url(../assets/icon-enter-code.png);
  background-size: cover;
  background-position: center center;
}

.slideList .slide{
  position: relative;
  width: 100%;
  height: 40px;

}
.slideList .slide .box{
  position: absolute;
  top: 16px;
  left: 15px;
  height: 8px;
  width: 8px;
  background-color: #c9c9c9;
}
.slideList .slide .title{
  position: absolute;
  top: 0px;
  left: 35px;
  right: 15px;
  height: 40px;
  line-height: 40px;
  color: #333333;
  font-size: 14px;
  word-wrap:break-word;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>



// WEBPACK FOOTER //
// src/view/enterprise-list-search.vue